<script setup lang="ts">
import { RouterView } from 'vue-router'
import { onMounted } from 'vue'
import { Toaster } from '@/components/ui/sonner'
import CookieBanner from '@/components/CookieBanner.vue'
import ImpersonationBanner from '@/components/ImpersonationBanner.vue'
import { useCookieConsent } from '@/composables/useCookieConsent'

const { initializeOnMount } = useCookieConsent()
onMounted(() => {
  initializeOnMount()
})
</script>

<template>
  <ImpersonationBanner />
  <CookieBanner />
  <RouterView />
  <Toaster position="top-right" richColors />
</template>
